import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadGTM, loadFBPixel, trackPageView } from '../../utils/analytics';

// Mounts Google Tag Manager + Meta Pixel once and sends a page_view on every
// route change (single-page-app behaviour Facebook/Google require).
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    loadGTM();
    loadFBPixel();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
